import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  public appConfig: any;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    this.http.get('assets/config/config.json')
      .toPromise()
      .then(data => {
        return this.appConfig = data;
      });
  }

  // This is an example property ... you can make it however you want.
  get configData() {
    return this.appConfig;
  }
}
